export default class DownloadCSV {
    execute(title, rows) {
        let a = document.createElement('a');
        const blob = new Blob([rows.map(row => {
            return row.map(cell => '"' + cell + '"').join(",");
        }).join("\n")], {'type': 'data:application/octet-stream'});
        a.href = window.URL.createObjectURL(blob);
        a.download = title + '.csv';
        a.click();
    }
}
